import { rgba, rem } from "polished"

const infoblocks = {
  backgroundColor: ({ theme }) => rgba(theme.colors.white, 0.6),
  openBackgroundColor: ({ theme }) => theme.colors.white,
  borderColor: ({ theme }) => rgba(theme.colors.blue, 0.2),
  borderRadius: rem(10),
}

export default infoblocks
